import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
function encodeParams(params) {
  return Object.keys(params).map(key => [key, params[key]].map(encodeURIComponent).join('=')).join('&');
}
const ContentfulImage = t0 => {
  const $ = _c(11);
  const {
    src,
    alt,
    width,
    height,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let srcSet;
  let t2;
  let t3;
  if ($[0] !== src) {
    const imageParams = {
      w: 480,
      h: 319,
      fit: "fill"
    };
    const widths = [480, 580, 600, 700, 800, 900, 1000, 1100];
    srcSet = widths.map(w => `${src}?${encodeParams({
      ...imageParams,
      w,
      h: w
    })} ${w}w`).join(", ");
    t2 = src;
    t3 = encodeParams(imageParams);
    $[0] = src;
    $[1] = srcSet;
    $[2] = t2;
    $[3] = t3;
  } else {
    srcSet = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  const publicSrc = `${t2}?${t3}`;
  let t4;
  if ($[4] !== alt || $[5] !== className || $[6] !== height || $[7] !== publicSrc || $[8] !== srcSet || $[9] !== width) {
    t4 = <img src={publicSrc} className={className} alt={alt} srcSet={srcSet} sizes="(max-width: 639px) 80vw, (max-width: 1023px) 33vw, 25vw" loading="lazy" width={width} height={height} />;
    $[4] = alt;
    $[5] = className;
    $[6] = height;
    $[7] = publicSrc;
    $[8] = srcSet;
    $[9] = width;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
ContentfulImage.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default ContentfulImage;